import type { JobPosting } from "~www/types/job";

import { FormError } from "@homeinstead/ui/components/FormError";
import { AnimatePresence } from "motion/react";
import { JobSelect } from "~www/components/LeadForm/CareGiver/JobSelect";

export type JobSelectionState =
  | "idle" // no org selected yet
  | "loading"
  | "error"
  | "has-jobs"
  | "no-jobs"; // no jobs available for the selected org

interface JobSectionProps {
  jobSelectionState: JobSelectionState;
  locationCareers?: JobPosting[];
  isOpen?: boolean;
  setIsOpen?: (open: boolean) => void;
}

export const JobSection = ({
  jobSelectionState,
  locationCareers,
  isOpen,
  setIsOpen,
}: JobSectionProps) => {
  switch (jobSelectionState) {
    case "idle":
      return null;
    case "loading":
      return <p>Loading jobs…</p>;
    case "error":
      return (
        <FormError.p className="text-error">Failed to load jobs.</FormError.p>
      );
    case "no-jobs":
      return (
        <FormError.p className="text-error">
          No jobs found for location.
        </FormError.p>
      );
    case "has-jobs":
      return (
        <AnimatePresence mode="wait">
          <JobSelect
            locationCareers={locationCareers}
            onOpenChange={setIsOpen}
            open={isOpen}
          />
        </AnimatePresence>
      );
  }
};
